import { styled } from 'styled-components';
import { htmlEncode } from '../../lib/utils/htmlEncode';

export const PrettyPrintedJsonContainer = styled.div`
	display: block;
	& .jsonKey {
		color: #5050B0;
	}
	& .jsonString {
		color: #500060;
	}
	& .jsonNumber {
		color: #206020;
	}
	& .jsonTrue {
		color: #007000;
	}
	& .jsonFalse {
		color: #800000;
	}
	& .jsonNull {
		color: #A06060;
	}
`

export const prettifyJsonString = (json: string): string => {
	const spanWithClassAndMatch = (cssClass: string, match: string) => 
		`<span class="${ cssClass }">${ htmlEncode(match) }</span>`;
	return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
		const spanWithClass = (cssClass: string) => spanWithClassAndMatch(cssClass, match);
			if (/^"/.test(match)) {
				if (/:$/.test(match)) {
					return spanWithClass("jsonKey");
				} else {
					if ( (match.startsWith("\"{") && match.endsWith("}\"")) ||
						( (match.startsWith("\"[") && match.endsWith("]\"")) )
					) {
						try {
							const jsonParsedString = JSON.parse(match);
							const jsonParsedObject = JSON.parse(jsonParsedString);
							if (jsonParsedObject != null) {
								return `<span class='jsonStringify'>JSON.stringify</span>(${
									prettifyJsonString(
										JSON.stringify(jsonParsedObject, null, '')
									).replaceAll("<br/>", `<br/>${"&nbsp;".repeat(8)}`)
								})`;							
							}
						} catch {}
					}
					return spanWithClass("jsonString");
				}
			} else if (/true|false/.test(match)) {
				return spanWithClass(match.toLocaleLowerCase() === 'true' ? "jsonTrue" : "jsonFalse");
			} else if (/null/.test(match)) {
				return spanWithClass("jsonNull");
			}
			return spanWithClass("jsonNumber");
		})
		.replaceAll('\t','&#32;&nbsp;')
		.replaceAll('\n','<br/>');
}



export const PrettyPrintedJsonObjectView = ({ objectToPrettyPrintAsJson }: { objectToPrettyPrintAsJson: object; }) => {
	const json = JSON.stringify(objectToPrettyPrintAsJson, null, '\t');
	const prettyJson = prettifyJsonString(json);
	return (
		<PrettyPrintedJsonContainer dangerouslySetInnerHTML={{ __html: prettyJson }} />
	);
};
